export default __webpack_public_path__ + "static/media/8bb62dba053f0252.321ec9f714f5ca1f6862553e9f819767.svg";